export default __webpack_public_path__ + "static/media/rotate-vehicle.b8554188.gif";